import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import Button from 'carbon-react/lib/components/button';
import Dialog from 'carbon-react/lib/components/dialog';
import Form from 'carbon-react/lib/components/form';
import Typography from 'carbon-react/lib/components/typography';

import { FormattedMessage, useIntl } from '@futrli/localisation';

import * as styles from '../../report-builder.scss';

interface Props {
  onClose: () => void;
  onConfirm: () => void;
  isModalOpen: boolean;
  title?: string;
  content?: string | ReactNode;
  isWorking?: boolean;
  confirmButtonText?: string;
  isLeftAligned?: boolean;
}

export const ConfirmModal: FC<Props> = ({
  onConfirm,
  onClose,
  isModalOpen,
  title,
  content,
  isWorking,
  confirmButtonText,
  isLeftAligned
}) => {
  const intl = useIntl();
  return (
    <Dialog
      title={
        <Typography fontSize="20px" fontWeight="600" pb="4px">
          {title || <FormattedMessage id="reporting.confirm_deletion" defaultMessage="Confirm deletion" />}
        </Typography>
      }
      onCancel={onClose}
      open={isModalOpen}
      size="medium"
      contentPadding={{
        p: 0
      }}
      aria-label={intl.formatMessage({
        id: 'reporting.delete_dialog.aria_label',
        defaultMessage: 'Delete dialog'
      })}
      className={classNames(styles.carbonModal, styles.noBackground)}
    >
      <Form
        stickyFooter
        leftSideButtons={
          <Button onClick={onClose} size="small" buttonType="secondary" disabled={isWorking}>
            <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
          </Button>
        }
        saveButton={
          <Button buttonType="primary" size="small" onClick={onConfirm} disabled={isWorking}>
            {confirmButtonText || <FormattedMessage id="common.confirm" defaultMessage="Confirm" />}
          </Button>
        }
        onSubmit={onConfirm}
      >
        <Typography px={3} py="20px" mb={0} textAlign={isLeftAligned ? 'left' : 'center'}>
          {content || (
            <FormattedMessage
              id="reporting.are_you_sure_to_delete"
              defaultMessage="Are you sure you want to delete this item?"
            />
          )}
        </Typography>
      </Form>
    </Dialog>
  );
};
